import {
  DeleteKEKOfferFromSystem,
  DeleteKEKOfferFromSystemVariables,
} from "_graphql/mutation/kek/__generated__/DeleteKEKOfferFromSystem";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import {
  deleteOfferFromSystem,
  sendHoldCover,
} from "_graphql/kek/mutation/index.kek";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";
import { wrapClick } from "utils";
import {
  SendHoldCover,
  SendHoldCoverVariables,
} from "_graphql/kek/mutation/__generated__/SendHoldCover";

export default function SendHoldCoverContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    SendHoldCover,
    SendHoldCoverVariables
  >(sendHoldCover, {
    refetchQueries: ["KEKOffers"],
  });

  const form = useFormik({
    initialValues: {
      reason: "",
    },
    onSubmit: async (values) => {
      await remove({
        variables: {
          offerId: searchParams?.id || "",
        },
      }).then(({ data }) => {
        if (data?.sendHoldCover) {
          toast.success("Hold Cover Sent Successfully");
          refetch?.();
          setOpen?.(false);
        } else {
          toast.error("Could not send hold cover");
        }
      });
    },
  });

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Send Hold Cover"
      cancelText="Abort"
      description="Do you wish to proceed to send hold cover ?"
      // reason="Reason"
      // form={form}
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Sending..." : "Send Hold Cover"}
          </button>
        </>
      )}
    />
  );
}
